import React from 'react';
import Button from "@mui/material/Button";
import {Box, Flex} from "reflexbox";
import logo from '../images/capital-clues-logo.png'
import { useNavigate } from "react-router-dom";
import {GAMEOVERVIEW} from "../components/helpers/routes";
import SkeletonImage from "../components/common/SkeletonImage";
import { useColorMode } from '../components/helpers/ColorModeContext';

const Welcome = () => {
  const navigate = useNavigate();
  const { mode } = useColorMode();

  function goToGameOverview() {
    navigate(GAMEOVERVIEW);
  }

  return (
    <Flex style={{flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', height: '100vh', paddingTop: '45%'}}>
      <SkeletonImage
        src={logo}
        alt="Capital Clues logo"
        skeletonHeight="180px"
        style={{width: '100%', marginTop: '16px'}}
        imgStyle={{ filter: mode === 'dark' ? 'invert(1)' : 'none' }}
      />
      <Box style={{textAlign: 'center', padding: '16px 0', lineHeight: '1.4'}}>Gamify your visit to the National Mall
        with our fun, clue solving adventure! </Box>
      <Button variant="contained" color="primary" onClick={() => goToGameOverview()}
              style={{width: '100%', marginTop: '16px'}}> Let's go! </Button>

    </Flex>
  )

};

export default Welcome;
